import { render, staticRenderFns } from "./reward-base-dialog.vue?vue&type=template&id=73d0465e"
import script from "./reward-base-dialog.vue?vue&type=script&lang=js"
export * from "./reward-base-dialog.vue?vue&type=script&lang=js"
import style0 from "./reward-base-dialog.vue?vue&type=style&index=0&id=73d0465e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports